import type { ContentPage } from "@/lib/content/types";

export const webforms: ContentPage = {
  slug: "omni-channels/webforms",
  template: "hrmsFeature",
  seo: {
    title: "CRM Web Forms - Capture Leads Straight Into Your CRM | GetBiz CRM",
    description:
      "Build web forms that create CRM records instantly with GetBiz CRM. Capture, route and follow up on every lead automatically — no manual data entry.",
    keywords: [
      "CRM web forms",
      "lead capture forms",
      "web to lead",
      "online form builder CRM",
      "contact form to CRM",
      "form automation",
    ],
    ogImage: "/assets/data/seoimages/webforms.webp",
  },
  leaf: {
    hero: {
      caption: "Webforms",
      title: "Capture Every Website Lead, Automatically",
      description:
        "Build and embed forms that create GetBiz CRM records the moment they're submitted — then score, assign and follow up automatically, with zero manual entry.",
      h1: "caption",
    },
    split: {
      title: "From Form Submission to Followed-up Lead",
      bullets: [
        { title: "Drag-and-drop Builder", description: "Create forms without a developer." },
        { title: "Instant CRM Records", description: "Submissions become leads immediately." },
        { title: "Auto-routing", description: "Assign new leads by your rules." },
        { title: "Spam Protection", description: "Keep junk out of your pipeline." },
      ],
      image: "/assets/images/img/product/crm/webforms-lead-image.webp",
      imageAlt: "GetBiz CRM web forms",
    },
    cardsHeading: { title: "More Omni Channels", description: "Web forms work with the rest of GetBiz CRM omni-channel." },
    cards: [
      { title: "Live Chat", href: "/crm-software/omni-channels/live-chat/", description: "Engage the visitors who don't fill forms.", image: "/assets/images/img/product/crm/live-chat.webp", imageAlt: "CRM live chat" },
      { title: "Email", href: "/crm-software/omni-channels/email/", description: "Auto-email new form leads instantly.", image: "/assets/images/img/product/crm/email.webp", imageAlt: "CRM email" },
      { title: "SMS", href: "/crm-software/omni-channels/sms/", description: "Text new leads for a fast first touch.", image: "/assets/images/img/product/crm/sms.webp", imageAlt: "CRM SMS" },
      { title: "Social Media", href: "/crm-software/omni-channels/social-media/", description: "Capture leads from social traffic too.", image: "/assets/images/img/product/crm/social-media.webp", imageAlt: "CRM social media" },
    ],
    testimonials: { title: "No lead left uncaptured", description: "See why teams capture leads with GetBiz CRM forms." },
    bookDemoTitle: "Start capturing leads automatically.",
    relatedBlogs: "slug",
    relatedBlogsKeyword: "web-forms-for-lead-generation, web-form-optimization-guide",
    metaKey: "webforms",
  },
  sections: [],
};
